// On a 401 the token is cleared and the browser is sent to the SSO login. But
// the customer portal auto-hands the JWT back, so if that token is stale/
// blacklisted (e.g. after a global logout) it would 401 again and loop forever.
// Guard: if we already redirected for auth moments ago, fall back to the public
// landing instead of hammering the login flow.
export function handleAuthExpiry(tokenKey: string, basePath: string): void {
  localStorage.removeItem(tokenKey);
  const now = Date.now();
  const last = Number(sessionStorage.getItem('auth_401_at') || '0');
  sessionStorage.setItem('auth_401_at', String(now));
  window.location.href = now - last < 8000 ? `${basePath}/` : `${basePath}/login`;
}
